import { useEffect } from 'react'

export default function App() {
  const onButtonClick = () => {
    window.location.href = "tmp.html";
  };
  

  return (
    <>
      <style>{`
        * {
          padding: 0;
          margin: 0;
          box-sizing: border-box;
        }
        html {
          --button-style-text: #000000;
          --button-style-background: #ffffff;
          --button-style-background-hover: #e8e8e8;
          --button-style-border: none;
          --button-style-border-color: transparent;
          --button-style-shadow: none;
          --button-style-shadow-color: #000000;
          --button-style-contrast-color: #000000;
          --button-style-radius: 8px;
          --button-style-inner-radius: min(var(--button-style-radius), max(4px, calc(var(--button-style-radius) - 8px)));
          --link-content-radius: min(var(--button-style-inner-radius), 14px);
          --button-style-inner-padding: var(--link-gap);
          --link-preview-thumbnail-width: 160px;
          --linkRadius: var(--button-style-radius);
          --background-contrast-color: #000000;
          --backdrop-contrast-color: #000000;
          --backdrop-contrast-color-inverse: #ffffff;
          --bodyText: #000000;
          --linkBackground: var(--button-style-background);
          --linkText: var(--button-style-text);
          --linkHoverBackground: var(--button-style-background-hover);
          --linkHoverText: var(--button-style-text);
          --profileBackground: #eceef1;
          --defaultAvatarBackground: #000000;
          --defaultAvatarText: #FFFFFF;
          --profileTitleText: #000000;
          --profileDescriptionText: #000000;
          --socialLinkFill: #000000;
          --bannerBackground: #ffffff;
          --bannerText: #000000;
          --linkShadow: #000000;
          --profileFontFamilyPrimary: sans‑serif;
          --profileFontFamilySecondary: Inter;
          --profileFontWeightNormal: 500;
          --profileFontWeightBold: 700;
          --profileDescriptionFontWeight: 500;
          --linkTextFontWeight: 500;
          --headerFontWeight: 700;
          --embedLinkTextFontWeight: 500;
          --signupSubmitTextFontWeight: 700;
          --bannerFontWeight: 700;
          --headerFontSize: normal;
          --embedLinkTextFontSize: 14px;
          --signupSubmitTextFontSize: 14px;
          --linkHeaderFontSize: 14px;
          --bannerFontSize: 14px;
          --profileDescriptionLineHeight: 1.5;
          --headerLineHeight: 1.5;
          --link-gap:14px;
          --profile-container-desktop-width:580px;
          --header-bio-font-size:16px;
        }
        @media screen and (min-width: 576px) {
          html {
            --embedLinkTextFontSize: 16px;
            --signupSubmitTextFontSize: 16px;
            --linkHeaderFontSize: 16px;
            --bannerFontSize: 16px;
            --link-preview-thumbnail-width: 224px;
          }
        }
        body {
          background-color: var(--profileBackground);
        }
        .LinkContainer_LinkContainer__lZ2Rk {
          display: grid;
        }
        .LinkContainer_actionButton__XiYgU {
          position:absolute;
          right:12px;
          top:50%;
          transform:translateY(-50%);
        }
      `}</style>

      <div style={{backgroundColor:'rgb(166, 168, 170)', minHeight:'100vh'}}>
        {/* 桌面端背景 */}
        <div className="hidden sm:block" style={{display:'none'}}>
          <div id="profile-backdrop" style={{position:'fixed',inset:0,zIndex:-1,width:'100%',height:'100%'}}>
            <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.2)',display:'none'}}></div>
          </div>
        </div>

        <div style={{paddingTop:'24px'}}>
          <div className="relative flex w-full flex-col overflow-x-hidden">
            <div id="profile-container-inner" style={{width:'100%',display:'flex',flexDirection:'column',minHeight:'100vh'}}>
              <div id="profile-frame" style={{maxWidth:'580px',margin:'0 auto',width:'100%'}}>
                <div className="anly-me" style={{backgroundColor:'#eceef1'}}>
                  <div id="profile-header" style={{paddingTop:'36px',position:'relative'}}>
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center',zIndex:1,position:'relative'}}>
                      {/* 头像 */}
                      <div id="profile-picture" style={{margin:'8px 0 16px'}}>
                        <img
                          alt="ריצ‘רד טננט"
                          src="/static/picture/a1.png"
                          style={{width:96,height:96,borderRadius:'50%'}}
                        />
                      </div>
                      <div id="profile-title">
                        <h1 style={{fontSize:'1.5rem',textAlign:'center',fontWeight:600,color:'#000',wordWrap:'break-word'}}>الأستاذ فهد بن محمد التميمي</h1>
                      </div>

                      {/* 简介 */}
                      <div id="profile-description" style={{marginTop:'8px',padding:'0 42px'}}>
                        <h2 style={{textAlign:'center',fontSize:18,lineHeight:1.8,color:'#000',wordWrap:'anywhere'}}>
                         كل يوم الساعة 9:00 صباحًا، سأشارك في مجموعة الأسهم الخاصة بي على واتساب تحليلات دقيقة لـ1 إلى 3 أسهم ذات توزيعات أرباح مرتفعة.
                        </h2>
                      </div>
                    </div>
                  </div>

                  {/* 链接列表 */}
                  <div id="profile-content" style={{position:'relative',zIndex:1,padding:'0 14px 16px'}}>
                    <div id="links-container" style={{display:'flex',flexDirection:'column',gap:'14px',marginTop:'24px'}}>

                      {/* 第一个卡片 */}
                      <div className="group" style={{opacity:1}}>
                        <div >
                          <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 16px',borderRadius:'8px',background:'#fff'}}>
                            <div style={{fontSize:18,sm:{fontSize:18},fontWeight:500,lineHeight:1.8,color:'#000'}}>
                             قبل ستة أشهر، أوصينا بشراء سهم SanDisk (SNDK) بسعر 488 دولارًا، والآن ارتفع سعر السهم إلى 1,588.23 دولارًا.
                            </div>
                          </div>
                           <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 16px',borderRadius:'8px',background:'#fff'}}>
                            <div style={{fontSize:18,sm:{fontSize:18},fontWeight:500,lineHeight:1.8,color:'#000'}}>
                             واليوم، سأشارك في مجموعة الأسهم الخاصة بنا على WhatsApp سهمًا آخر يتمتع بإمكانات نمو قوية. يتمتع هذا السهم بإمكانية كبيرة لتحقيق ارتفاعات مستقبلية.
                            </div>
                          </div>

                           <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 16px',borderRadius:'8px',background:'#fff'}}>
                            <div style={{fontSize:18,sm:{fontSize:18},fontWeight:500,lineHeight:1.8,color:'#000'}}>
السعر الحالي للسهم: 8.08 ريال سعودي
السعر المستهدف: 338.80 ريال سعودي
استثمار 5,000 سهم قد يرتفع إلى 51 مليون ريال سعودي خلال ستة أشهر.
                            </div>
                          </div>

                           <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 16px',borderRadius:'8px',background:'#fff'}}>
                            <div style={{fontSize:18,sm:{fontSize:18},fontWeight:500,lineHeight:1.8,color:'#000'}}> 
لماذا تحظى مجموعة الأسهم الخاصة بي بشعبية كبيرة؟
لأنني لا أفرض أي رسوم، ولا توجد رسوم عضوية، ولا توجد أي تكاليف أو شروط مخفية.
                            </div>
                          </div>
                          <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 16px',borderRadius:'8px',background:'#fff'}}>
                            <div style={{fontSize:18,sm:{fontSize:18},fontWeight:500,lineHeight:1.8,color:'#000'}}>
انضم إلى مجموعة WhatsApp الخاصة بنا واحصل مجانًا على توصيات الأسهم وتحليلات السوق من الخبراء.
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 带大图链接 */}
                      <div className="group">
                        <div className="LinkContainer_LinkContainer__lZ2Rk">
                          <div
                            target="_blank"
                            rel="noopener noreferrer"
                           
                            style={{width:'100%',display:'block',borderRadius:'8px',overflow:'hidden'}}
                          >
                            <div style={{width:'100%',aspectRatio:'16/9'}}>
                              <img
                                alt="الأستاذ فهد بن محمد التميمي Join our WhatsApp group now to receive the latest stock insights."
                                src="/static/picture/a2.png"
                                style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'8px'}}
                              />
                            </div>
                          </div>
                          <div style={{minHeight:64,width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',padding:'12px 32px',background:'#fff',borderRadius:'8px'}}>
                            <div onClick={onButtonClick} style={{textAlign:'center',fontSize:18,fontWeight:500,color:'#000',lineHeight:1.8}}>
                             نضم الآن إلى مجموعة WhatsApp الخاصة بي واحصل على أحدث أخبار الأسهم والمعلومات حول الأسهم التي يُتوقع أن ترتفع قريبًا.
                            </div>
                          </div>
                        </div>
                      </div>
                     

                      {/* 第三个带小图按钮 */}
                      <div className="group">
                        <div className="LinkContainer_LinkContainer__lZ2Rk">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="#"
                            style={{width:'100%',display:'block'}}
                          >
                            <div style={{minHeight:64,width:'100%',display:'flex',alignItems:'center',padding:'8px 16px',background:'#fff',borderRadius:'8px',position:'relative'}}>
                              <div style={{width:48,height:48,overflow:'hidden',borderRadius:'8px',flexShrink:0}}>
                                <img alt="" src="/static/picture/img03.webp" style={{width:'100%',height:'100%',objectFit:'cover'}} />
                              </div>
                              <div onClick={onButtonClick} style={{flex:1,textAlign:'center',fontSize:16,fontWeight:500,color:'#000'}}>
                               WhatsApp
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 页脚 */}
                  <div id="profile-footer" style={{padding:'48px 0 64px',display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <div style={{display:'flex',flexWrap:'wrap',justifyContent:'center',gap:'4px',fontSize:'12px',color:'#000'}}>
                      <button style={{background:'none',border:'none'}}>إعدادات ملفات تعريف الارتباط</button>
                      <span>•</span>
                      <a href="#" target="_blank" rel="noopener noreferrer">الإبلاغ</a>
                      <span>•</span>
                      <a href="#" target="_blank" rel="noopener noreferrer">سياسة الخصوصية</a>
                       <span>•</span>
                       <a href="#" target="_blank" rel="noopener noreferrer">معلومات عن هذا الحساب</a>
                        <span>•</span>
                        <a href="#" target="_blank" rel="noopener noreferrer">المزيد من Linktree</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}